import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './ClusterBeansPage.css';
import clusterbeansLogo from '../images/clusterbeans-logo.png';
import radhika from '../images/clusterbeans-radhika-img.png';

const varieties = [
  {
    name: 'RADHIKA',
    image: radhika,
    description: [
      'Early harvesting in just 40-45 days after sowing',
      'Uniform, light green pods of 8-10 cm length',
      'High pod count per cluster (8-10 pods)',
      'Strong, erect plants with 100-120 cm height',
      'Adaptable to both Kharif and Rabi seasons',
    ],
  },
 
 
];

export default function ClusterBeansPage() {
  return (
    <ProductPatternPage
      title="Cluster Beans"
      varieties={varieties}
      pageClass="clusterbeans-page"
      heroImage={clusterbeansLogo}
    />
  );
}
